export { default as ErrorFallback } from './ErrorFallback';
